import React from "react";
import ErrorPage from "pages/ErrorPage/ErrorPage";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminSettingsWorkspacePage from "pages/AdminView/AdminSettingsWorkspacePage/AdminSettingsWorkspacePage";
import RecruiterSettingsWorkspacePage from "pages/RecruitersView/RecruiterSettingsWorkspacePage/RecruiterSettingsWorkspacePage";

export default function SettingsWorkspaceSwitch() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    return <AdminSettingsWorkspacePage />;
  } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
    return <RecruiterSettingsWorkspacePage />;
  } else {
    return <ErrorPage />;
  }
}
